<template>
  <div v-if="$route.name !== 'Articulos'">
    <v-skeleton-loader
      v-if="!MaestroSubCat"
      fade-transition
      height="94"
      type="list-item-three-line"
    >
    </v-skeleton-loader>
    <div v-else>
      <v-list
        nav
        dense
        v-if="tipoB ? ttCategoriaNew : subCat(this.$route.params.cat)"
      >
        <v-list-item-group color="primary" v-model="selectedItem">
          <template>
            <v-list-item
              dense
              rounded
              :disabled="loadingSubCat && parseInt(item.SubCategoria) === parseInt($route.params.scat)"
              v-for="(item, w) in tipoB
                ? ttCategoriaNew
                : subCat($route.params.cat)"
              :key="`${w}-${item.SubCategoria}`"
            >
              <v-list-item-icon
                class="ml-n3"
                v-show="
                  tipoB === true &&
                  idscat === true &&
                  parseInt(item.SubCategoria) === parseInt(wSesionSt()) &&
                  parseInt(item.Categoria) === parseInt($route.params.cat)
                "
              >
                <v-icon color="#37474F" size="28" @click="idscatF"
                  >mdi-close-circle</v-icon
                >
              </v-list-item-icon>
              <v-list-item-content @click="idSubCat({ item })">
                <v-list-item-title
                  :class="[
                    {
                      'font-weight-black caption':
                        parseInt(item.SubCategoria) === parseInt(wSesionSt()) &&
                        parseInt(item.Categoria) ===
                          parseInt($route.params.cat),
                    },
                  ]"
                >
                  {{ item.Nombre }}
                </v-list-item-title>
              </v-list-item-content>
             
              <span
                class="text--disabled body-2"
                v-if="
                  !(
                    parseInt(item.SubCategoria) === parseInt(wSesionSt()) &&
                    parseInt(item.Categoria) === parseInt($route.params.cat)
                  )
                "
              >
              {{ item.Items }}</span
              >

              <v-badge
                v-if="
                  !loadingSubCat && parseInt(item.SubCategoria) === parseInt($route.params.scat)
                "
                inline
                color="primary"
                :content="filterconsolidado.length"
                class="font-weight-medium body-2 ml-2"
              >
              </v-badge>
              <!--  <v-divider
              v-if="w + 1 < tipoB ? ttCategoriaNew.length : subCat($route.params.cat).length"
              :key="w"
            ></v-divider> -->
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>

<script>
import exportarPdf from "./ExportarPdf";
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  name: "listascat",
  data() {
    return {
      search: "",
      checkScat: [],
      selectedItem: -1,
      activo: false,
    };
  },
  components: {
    exportarPdf,
  },
  watch: {
    $route(to, from) {
      this.checkScat = [];
    },
    deep: true,
    immediate: true,
  },
  created() {},
  methods: {
    ...mapMutations([
      "CLR_BUSCARSCAT",
      "CLR_DATOS_SUBCATB",
      "set_varCategorias",
      "setMenuDomoDeco",
      "set_idscatF",
      "set_AdPromoF",
      "set_idscatT",
      "CLR_BUSCAREPUESTO",
      "GET_BUSCARSCAT",
      "GET_BUSCARCAT",
      "set_changeSubcat",
      "GET_BUSCAREPUESTO",
      "CLR_BUSCARMARCA",
      "CLR_BUSCARPROMO",
      "set_checkRepuestoF",
      "set_subcategoria",
      "clr_page",
    ]),
    toTopGo() {
      window.scrollTo(0, 0);
    },
    limpiaScat() {
      this.checkScat = [];
      this.CLR_BUSCARSCAT();
    },
    wSesionSt() {
      return parseInt(window.localStorage.getItem("subcat"));
    },
    idscatF() {
      // this.idscat = false;
      this.set_idscatF();
      this.CLR_BUSCARSCAT();
    },
    idSubCat({ item: { CodigoDiv, CodigoDep, Categoria, SubCategoria } }) {
      this.CLR_DATOS_SUBCATB();
      this.set_AdPromoF();
      this.setMenuDomoDeco(false);
      this.$vuetify.goTo(0);
      this.CLR_BUSCARSCAT();
      this.CLR_BUSCARMARCA();
      //this.CLR_PROMO();
      this.set_subcategoria(SubCategoria);
      this.set_changeSubcat();
      this.GET_BUSCARSCAT(SubCategoria);
      this.set_varCategorias([CodigoDiv, CodigoDep, Categoria]);
      // this.consolidadoSCategoria();
      window.localStorage.setItem("subcat", JSON.stringify(SubCategoria));
      this.$router.push(
        `/Catalogo/${CodigoDiv}/${CodigoDep}/${Categoria}/${SubCategoria}`
      );
    },

  },
  computed: {
    ...mapState([
      "SubCategorias",
      "loadingSubCat",
      "maestro",
      "ttCatalogo",
      "changeSubcat",
      "ttArticuloAll",
      "tabBusqueda",
      "idscat",
      "tipoB",
      "SubCategoriasBuscar",
      "filter",
      "dataUser",
    ]),
    ...mapGetters(["filterconsolidado"]),
    MaestroSubCat() {
      if (Object.entries(this.maestro).length !== 0) {
        return this.maestro.ttSubCategoria.filter(
          (x) => x.Categoria === parseInt(this.$route.params.cat)
        );
      }
    },
    subCat: function () {
      let cp = [],
        xData = [];
      return function (id) {
        if (Object.entries(this.maestro).length !== 0) {
          // return this.maestro.ttSubCategoria[1]//.filter(x => x.Categoria === id)
          cp = [];
          cp.push(
            this.maestro.ttSubCategoria.filter(
              (item) => item.Categoria == id && item.StatusWeb === true
            )
          );
          return cp[0];
        }
        // let total = 0;
      };
    },
    numMaqui: function () {
      return function (id) {
        if (this.ttCatalogo) {
          if (id === 0)
            return this.ttCatalogo
              .filter((x) => x.Catalogo === "Maquina")
              .map((x) => x.JsonItem);
          if (id === 1)
            return this.ttCatalogo
              .filter((x) => x.Catalogo === "Repuesto")
              .map((x) => x.JsonItem);
        }
      };
    },
    subcatItem: function () {
      return function (id) {
        let xdata = 0;

        if (this.SubCategoriasBuscar) {
          if (this.tabBusqueda === 0) {
            xdata = this.SubCategoriasBuscar.filter(
              (x) => x.Maquina > 0 && x.SubCategoria === id
            ).map((x) => x.Maquina);
          }
          if (this.tabBusqueda === 1) {
            xdata = this.SubCategoriasBuscar.filter(
              (x) => x.Repuesto > 0 && x.SubCategoria === id
            ).map((x) => x.Repuesto);
          }
          return xdata[0];
        }
      };
    },
    subcatItemGrid: function () {
      return function (id) {
        let xdata = 0;

        if (this.SubCategorias) {
          xdata = this.SubCategorias.filter(
            (x) => x.Items > 0 && x.SubCategoria === id
          ).map((x) => x.Items);

          return xdata[0];
        }
      };
    },
    ttCategoriaNew: {
      get: function () {
        if (this.changeSubcat === true) {
          this.checkScat = [];
        }
        let xSubCat = [];
        let idb = null;
        if (this.tabBusqueda === 0) idb = "Maquina";
        if (this.tabBusqueda === 1) idb = "Repuesto";
        if (Object.entries(this.SubCategorias).length !== 0) {
          xSubCat = this.SubCategorias.filter((x) => x.SubCategoria != 0);
        }
        if (Object.entries(this.SubCategoriasBuscar).length !== 0) {
          if (this.tabBusqueda === 0) {
            if (this.numMaqui(0) > 0) {
              xSubCat = this.SubCategoriasBuscar.filter(
                (x) => x.SubCategoria != 0 && x.Maquina > 0
              );
            } else {
              xSubCat = this.SubCategoriasBuscar.filter(
                (x) => x.SubCategoria != 0 && x.Repuesto > 0
              );
            }
          }

          if (this.tabBusqueda === 1) {
            if (this.numMaqui(1) > 0) {
              xSubCat = this.SubCategoriasBuscar.filter(
                (x) => x.SubCategoria != 0 && x.Repuesto > 0
              );
            } else {
              xSubCat = this.SubCategoriasBuscar.filter(
                (x) => x.SubCategoria != 0 && x.Maquina > 0
              );
            }
          }
        }

        return xSubCat;
      },
    },
    numitems() {
      if (this.filterconsolidado) return this.filterconsolidado.length;
    },
  },
  props: {},
};
</script>
